import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useHistory } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import clsx from 'clsx';

import {
  AppBar,
  Button,
  IconButton,
  Toolbar,
  Hidden,
  useMediaQuery,
  useTheme,
  Typography,
  Link,
} from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';
import MenuIcon from '@material-ui/icons/Menu';
import WarningIcon from '@material-ui/icons/Warning';

import styles from './styles';
import { signOut } from '../../../thunks';

function TopBar({ onOpenNavBarMobile, user, enterprise, className, dispatch }) {
  const classes = styles();
  const history = useHistory();

  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  const {
    isPooling,
    isVerified,
    isConnected,
    balance,
    credit_balance,
    reserved_balance,
  } = user;

  const currency = get(enterprise, 'currency', 'USD');

  const handleLogout = () => {
    dispatch(signOut());
    history.push('/auth/login');
  };

  const currentBalance = balance + credit_balance - reserved_balance;

  return (
    <AppBar
      id="main-top-bar"
      className={clsx(classes.root, className)}
      color="primary"
    >
      <Toolbar>
        <Hidden lgUp>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            onClick={onOpenNavBarMobile}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
        <RouterLink to="/channels" />
        <div className={classes.flexGrow} />
        {user?.info?.email === 'ira@mmdsmart.com' && (
          <Link
            underline="none"
            color="inherit"
            target="_blank"
            href="https://sms.mmdsmart.com/app/send"
          >
            <Button
              style={{ margin: '0 18px' }}
              color="inherit"
              size="small"
              variant="outlined"
              to=""
            >
              MW Portal
            </Button>
          </Link>
        )}
        {isPooling && !isVerified && (
          <>
            <div className={classes.warningButton}>
              <WarningIcon />
            </div>
            <Typography
              variant="h6"
              align="center"
              className={classes.verificationMessage}
            >
              Your account is currently being validated. Please wait for the
              validation will be completed or contact
              customer.onboarding@mmdsmart.com
            </Typography>
          </>
        )}
        {isPooling && isConnected ? (
          <Typography style={{ color: '#fff' }} variant="h6">
            {(currentBalance / 100).toFixed(2)} {currency}
          </Typography>
        ) : null}
        <Typography
          id="main-top-bar-email"
          className={classes.userEmail}
          variant="h6"
        >
          {user?.info?.email || ''}
        </Typography>
        <Button
          id="logout-btn"
          className={classes.logoutButton}
          color="inherit"
          onClick={handleLogout}
        >
          <InputIcon className={classes.logoutIcon} />
          <Hidden xsDown>
            <Typography
              style={{ color: '#fff' }}
              align="center"
              variant={mobileDevice ? 'h6' : 'inherit'}
            >
              Sign out
            </Typography>
          </Hidden>
        </Button>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  enterprise: PropTypes.shape({}).isRequired,
  user: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

TopBar.defaultProps = {
  className: '',
};

export default connect(({ enterprise, user }) => ({
  enterprise,
  user,
}))(TopBar);
